import React from 'react';
import Form from '../components/form/SearchForm';
import Movies from '../components/movie/Movies';

const Home = () => {
  return (
    <main>
      <Form />
      <Movies />
    </main>
  );
};

export default Home;
